import { Box, Popover, Typography } from "@material-ui/core";
import React from "react";
import { ITaxForm } from "./form/AdminTaxFormsPage";
import { X } from "lucide-react";

type Field = {
    label: string;
    value: string | number | null;
};

type TaxFormPopupProps = {
    title: string;
    fields: Field[] | null;
    viewOpen: boolean;
    setViewOpen: (open: boolean) => void
    // viewItem: ITaxForm | null,
    anchorEl: HTMLButtonElement | null,
    setAnchorEl: (el: HTMLButtonElement | null) => void
}

export function DetailPopup({ title, fields, viewOpen, setViewOpen, anchorEl, setAnchorEl }: TaxFormPopupProps) {

    const handleClose = () => {
        setViewOpen(false);
        setAnchorEl(null)
    }

    return (
        <>
            <Popover
                open={viewOpen}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                PaperProps={{
                    style: {
                        borderRadius: 12,
                        marginTop: 7,
                    },
                }}

            >
                <Box style={{ color: "#fff", padding: 12, display: "block", gap: 8 }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography style={{ fontSize: 18, marginRight: 20 }}><b>{title}</b></Typography>
                        <X size={20} onClick={handleClose} />
                    </Box>
                    {fields && <InfoGrid fields={fields} />}
                </Box>
            </Popover>
        </>
    );
}

const InfoGrid = ({ fields }: { fields: Field[] }) => {
    return (
        <Typography style={{ fontSize: 14, display: "grid", gap: 4, marginTop: 8 }}>
            {fields.map((field, idx) => (
                <div key={idx} style={{ display: "flex", gap: 12 }}>
                    <b>{field.label}:</b>
                    <span style={{ color: "#FFFFFFCC" }}>{field.value ?? "—"}</span>
                </div>
            ))}
        </Typography>
    );
};